export default __webpack_public_path__ + "img/img/profiles.5b568214.svg";